export default {
  key: 'G',
  suffix: 'm9b5',
  positions: [{
    frets: '3110',
    fingers: '3120'
  }, {
    frets: '2111',
    fingers: '2111',
    barres: 1,
    capo: true
  }, {
    frets: '3554',
    fingers: '1342'
  }, {
    frets: '6968',
    fingers: '1413',
    barres: 6
  }]
};